import {
  GET_EXERCISE_ASSIGNMENT,
  CREATE_EXERCISE_ASSIGNMENT,
  UPDATE_EXERCISE_ASSIGNMENT,
  DELETE_EXERCISE_ASSIGNMENT,
  axios,
  baseURL,
} from "./types";

// Get All Assignments
export const getExerciseAssignments = (data) => (dispatch) => {
  var config = {
    method: "post", // Following your pattern
    url: baseURL + "/api/appointmentAssignment/getall",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: data,
  };

  return axios(config)
    .then((response) => {
      dispatch({
        type: GET_EXERCISE_ASSIGNMENT,
        payload: response.data,
      });
      return response;
    })
    .catch((error) => {
      console.error(error);
      throw error;
    });
};

// Create Assignment
export const createExerciseAssignment = (data) => (dispatch) => {
  // Ensure the assigned_by uses the stored hospital/assigned-id
  const payload = {
    ...data,
    assigned_by: localStorage.getItem("assigned-id") || data.assigned_by
  };

  var config = {
    method: "post",
    url: baseURL + "/api/appointmentAssignment/create",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
    data: payload,
  };

  return axios(config)
    .then((response) => {
      dispatch({
        type: CREATE_EXERCISE_ASSIGNMENT,
        payload: response.data,
      });
      return response;
    })
    .catch((error) => {
      console.error(error);
      throw error;
    });
};

// Update Assignment
export const updateExerciseAssignment = (formData) => (dispatch) => {
  var config = {
    method: "patch",
    url: baseURL + "/api/appointmentAssignment/update",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: formData,
  };

  return axios(config)
    .then((response) => {
      dispatch({
        type: UPDATE_EXERCISE_ASSIGNMENT,
        payload: response.data,
      });
      return response;
    })
    .catch((error) => {
      console.error("Update API Error:", error);
      throw error;
    });
};

// Delete Assignment
export const deleteExerciseAssignment = (data) => (dispatch) => {
  var config = {
    method: "delete",
    url: baseURL + "/api/appointmentAssignment/delete",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: data,
  };

  return axios(config)
    .then((response) => {
      dispatch({
        type: DELETE_EXERCISE_ASSIGNMENT,
        payload: response.data,
      });
      return response;
    })
    .catch((error) => {
      console.error(error);
      throw error;
    });
};